import { useState } from "react";
import { useDispatch } from "react-redux";
import useInput from "../../hooks/userInput";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { BsKeyFill, BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { HiArrowRightOnRectangle, HiOutlineKey } from "react-icons/hi2";

import cf from "../UI/ClassicForm.module.css";
import { alertActions } from "../../store/alert-slice";
import Spinner from "../UI/Spinner";
import { resetPassword } from "../../api/api";

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setconfirmPasswordType] = useState("password");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const setCookie = useCookies(["jwt"])[1];
  const [showSpinner, setShowSpinner] = useState(false);
  const params = useParams();

  const {
    value: passwordInput,
    enteredValueIsValid: passwordInputIsValid,
    hasError: passwordInputIsInvalid,
    valueInputChangedHandler: passwordInputChangedHandler,
    valueInputBlurHandler: passwordInputBlurHandler,
    reset: passwordInputReset,
  } = useInput((value) => value.trim() !== "");
  const {
    value: confirmPasswordInput,
    enteredValueIsValid: confirmPasswordInputIsValid,
    hasError: confirmPasswordInputIsInvalid,
    valueInputChangedHandler: confirmPasswordInputChangedHandler,
    valueInputBlurHandler: confirmPasswordInputBlurHandler,
    reset: confirmPasswordInputReset,
  } = useInput((value) => value.trim() !== "");

  let formIsValid = false;
  if (passwordInputIsValid && confirmPasswordInputIsValid) {
    formIsValid = true;
  }

  const switchEyeIcon = () => {
    setShowPassword((initialstate) => !initialstate);
  };

  const switchEyeIcon2 = () => {
    setShowConfirmPassword((initialstate) => !initialstate);
  };

  const switchType = (val) => {
    setPasswordType(val);
  };

  const switchType2 = (val) => {
    setconfirmPasswordType(val);
  };

  const passwordActionSee = () => {
    switchEyeIcon();
    switchType("text");
  };

  const passwordActionSee2 = () => {
    switchEyeIcon2();
    switchType2("text");
  };
  const passwordActionBlind = () => {
    switchEyeIcon();
    switchType("password");
  };

  const passwordActionBlind2 = () => {
    switchEyeIcon2();
    switchType2("password");
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowSpinner(true);

    const data = {
      password: passwordInput,
      passwordConfirm: confirmPasswordInput,
    };

    const res = await resetPassword(data, params.token);

    if (res.status === "success") {
      setCookie("jwt", res.token);
      dispatch(
        alertActions.setState({ message: res.message, status: res.status })
      );
      navigate("/", { replace: true });
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }

    setShowSpinner(false);

    passwordInputReset();
    confirmPasswordInputReset();
    setTimeout(() => {
      dispatch(alertActions.resetState());
    }, 3000);
  };

  const passwordInputClasses = passwordInputIsInvalid
    ? `${cf.field} ${cf.invalid}`
    : cf.field;

  const confirmPasswordInputClasses = confirmPasswordInputIsInvalid
    ? `${cf.field} ${cf.invalid}`
    : cf.field;

  return (
    <form className={cf.form} onSubmit={submitHandler}>
      {showSpinner && <Spinner />}
      <div className={cf.formTitleRow}>
        <HiOutlineKey className={cf.formTitleIcon} aria-hidden />
        <h2 className={cf.formTitle}>Choose a new password</h2>
      </div>
      <p className={cf.formSubtitle}>
        Enter your new password twice, then proceed to sign in.
      </p>
      <div className={passwordInputClasses}>
        <label htmlFor="reset-new">New password</label>
        <div className={cf.inputGroup}>
          <BsKeyFill className={cf.icon} />
          <input
            id="reset-new"
            type={passwordType}
            autoComplete="new-password"
            value={passwordInput}
            onChange={passwordInputChangedHandler}
            onBlur={passwordInputBlurHandler}
          />
          {!showPassword && (
            <BsEyeFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActionSee}
              role="button"
              tabIndex={0}
              aria-label="Show password"
            />
          )}
          {showPassword && (
            <BsEyeSlashFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActionBlind}
              role="button"
              tabIndex={0}
              aria-label="Hide password"
            />
          )}
        </div>
      </div>
      <div className={confirmPasswordInputClasses}>
        <label htmlFor="reset-confirm">Confirm new password</label>
        <div className={cf.inputGroup}>
          <BsKeyFill className={cf.icon} />
          <input
            id="reset-confirm"
            type={confirmPasswordType}
            autoComplete="new-password"
            value={confirmPasswordInput}
            onChange={confirmPasswordInputChangedHandler}
            onBlur={confirmPasswordInputBlurHandler}
          />
          {!showConfirmPassword && (
            <BsEyeFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActionSee2}
              role="button"
              tabIndex={0}
              aria-label="Show password"
            />
          )}
          {showConfirmPassword && (
            <BsEyeSlashFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActionBlind2}
              role="button"
              tabIndex={0}
              aria-label="Hide password"
            />
          )}
        </div>
      </div>
      <div className={cf.actions}>
        <button type="submit" disabled={!formIsValid}>
          <HiArrowRightOnRectangle className={cf.btnIcon} aria-hidden />
          Proceed
        </button>
      </div>
    </form>
  );
};

export default ResetPassword;
